import React from 'react';
import national_1x from '../../image/national_1x.png';
import upArrow from "../../image/up-arrow.png";
import styles from "../algorithm_components/Accordion/Accordion.module.css";
import {MAIN_URL} from '../../constants'
class AlgorithmsDetails extends React.Component {
    state = {
        bookSelection: []
    };

    componentDidMount = async () => {
          const url = `${MAIN_URL}/wp-json/wp/v2/posts?categories=${this.props.category?this.props.category.id:1}&per_page=100`;
        const requestData = await fetch(url, {method: 'GET'});
        const responseData = await requestData.json();
        const bookSelection = responseData.map(book => {
            const booksList = {...book};
            return booksList;
        });
        await this.setState({bookSelection: bookSelection})
    }

    render() {
        const books = this.state.bookSelection;
        let allBooks = this.props.allBooks ? this.props.allBooks : []
        // console.log('books', books)
        return (
            <div>
                {(books.length > 0 && allBooks.length === 0) ?
                    books.map(book =>
                        <div style={{
                            margin: 15,
                            marginBottom: 35,
                            fontFamily: 'century gothic',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'start',
                        }}
                             key={book.id}>
                            <div style={{
                                borderRadius: '0.3em',
                                padding: '0.7em 2em',
                                backgroundColor: '#e95095',
                                borderColor: 'transparent',
                                color: '#fff!important',
                                boxShadow: 'none',
                                marginRight: '1em',
                            }}><img style={{width: '1.5em'}} src={national_1x} alt=""/></div>
                            <a style={{
                                textDecorationLine: 'none',
                                color: "black",
                                fontSize: 18,
                                fontWeight: '600',
                            }}
                               href={book.acf.link}
                               target="_blank">
                                {book.title.rendered}
                            </a>
                        </div>
                    ) :
                    allBooks.map(book =>
                        <div style={{
                            margin: 15,
                            marginBottom: 35,
                            fontFamily: 'century gothic',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'start',
                        }}
                             key={book.id}>
                            <div style={{
                                borderRadius: '0.3em',
                                padding: '0.7em 2em',
                                backgroundColor: '#e95095',
                                borderColor: 'transparent',
                                color: '#fff!important',
                                boxShadow: 'none',
                                marginRight: '1em',
                            }}><img style={{width: '1.5em'}} src={national_1x} alt=""/></div>
                            <a style={{
                                textDecorationLine: 'none',
                                color: "black",
                                fontSize: 18,
                                fontWeight: '600',
                            }}
                               href={book.acf.link}
                               target="_blank">
                                {book.title.rendered}
                            </a>
                        </div>
                    )
                }
            </div>
        )
    }
}

export default AlgorithmsDetails;